var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.renderingAdapter.config.tag,{tag:"component",staticClass:"world-map-viewer",attrs:{"height":_vm.height,"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }